module.exports = __webpack_public_path__ + "images/icons/cards/american-express-7313b680.svg";